'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const SanitizeHtml = require('../../global/components/SanitizeHtml');

function HeroItem(props) {
    const {title, url, image} = props.item;
    const index = props.index;

    return (
        <a className="hero-carousel-item" href={url} data-index={index} onClick={() => props.onClick(props.item, index)}>
            <div className="hero-carousel-item-image-wrapper">
                <img className="hero-carousel-item-image is-centered" src={image} alt={title} />
            </div>
            <span className="hero-carousel-item-title">
                <SanitizeHtml content={title} allowedTags={['i']} />
            </span>
        </a>
    );
}

HeroItem.propTypes = {
    index: PropTypes.number,
    item: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.string
    }),
    onClick: PropTypes.func
};

module.exports = HeroItem;



// WEBPACK FOOTER //
// ./assets/js/home/components/HeroItem.jsx